import { render, staticRenderFns } from "./PlacementsStartComponentDevelopmentGraduate.vue?vue&type=template&id=a13f8380&scoped=true&"
import script from "./PlacementsStartComponentDevelopmentGraduate.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentDevelopmentGraduate.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentDevelopmentGraduate.vue?vue&type=style&index=0&id=a13f8380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f8380",
  null
  
)

export default component.exports